import { useAppDispatch } from 'app/hooks';
import { ProjectSettingCodeType } from 'data/types';
import { updateProjectSetting } from 'features/project';
import {
  convertBooleanValueToYesNo,
  convertYesNoValueToBoolean
} from 'utils/attributes';
import { isNotEmpty } from 'utils/helpers';
import { getProjectSetting } from 'utils/project';
import AttributeComponent from './attribute';

type ProjectSettingBooleanProps = {
  code: ProjectSettingCodeType;
  showProgress?: boolean;
  showLabel?: boolean;
  required?: boolean;
  debounce?: number;
  disabled?: boolean;
  autoFocus?: boolean;
  onChange?: (value?: string) => void;
  width?: number;
  preventDeselection?: boolean;
};

export default function ProjectSettingBoolean({
  code,
  showProgress = false,
  showLabel = false,
  required,
  debounce,
  disabled,
  autoFocus,
  onChange,
  width,
  preventDeselection
}: ProjectSettingBooleanProps) {
  const dispatch = useAppDispatch();
  const setting = getProjectSetting(code);

  if (!setting) {
    return <div className='text-red-500'>{code} not found!</div>;
  }

  const displayValue = convertBooleanValueToYesNo(setting.value);

  const handleChange = (value: string) => {
    const convertedValue = convertYesNoValueToBoolean(value);

    dispatch(
      updateProjectSetting({
        attributeId: setting.id,
        value: convertedValue
      })
    );

    onChange?.(value);
  };

  return (
    <AttributeComponent
      key={`${setting.id}-${setting.value ?? 'undefined'}`}
      {...setting}
      type='select'
      options={['Yes', 'No']}
      value={displayValue}
      showProgress={showProgress}
      showLabel={showLabel}
      completed={isNotEmpty(setting.value)}
      required={required}
      debounce={debounce}
      disabled={disabled}
      autoFocus={autoFocus}
      onChange={handleChange}
      width={width}
      preventDeselection={preventDeselection}
    />
  );
}
